import React from "react";
import { Facebook, Youtube, Instagram, Mail, Phone, MapPin, Cross, Heart } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer({ info }) {
  return (
    <footer id="don" className="relative bg-deepblue-900 text-white pt-20 pb-8 overflow-hidden">
      <div className="absolute inset-0 grain opacity-50" />
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              {info?.logo_url ? (
                <img src={info.logo_url} alt={info?.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-gold/60 bg-white" />
              ) : (
                <span className="w-12 h-12 rounded-full bg-white/5 border border-gold/40 text-gold flex items-center justify-center">
                  <Cross className="w-6 h-6" strokeWidth={2.4} />
                </span>
              )}
              <div>
                <div className="font-serif text-2xl">{info?.name}</div>
                <div className="text-gold text-xs tracking-widest uppercase">Foi · Amour · Espérance</div>
              </div>
            </div>
            <p className="text-white/60 leading-relaxed max-w-md">
              {info?.slogan} — Rejoignez notre communauté et vivez une rencontre authentique
              avec Dieu chaque semaine.
            </p>

            <div className="mt-8 rounded-2xl border border-gold/30 bg-gold/5 p-6">
              <div className="flex items-center gap-2 text-gold text-xs tracking-widest uppercase">
                <Heart className="w-3.5 h-3.5 fill-gold" /> Soutenir l'église
              </div>
              <p className="mt-2 text-white/80 text-sm">
                Votre don soutient les activités, l'aide aux plus démunis et la mission.
              </p>
              <a
                href={info?.donation_url || "#"}
                data-testid="footer-donate-btn"
                className="mt-4 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-gold hover:bg-gold-hover text-white font-semibold text-sm transition-colors"
              >
                Faire un don <Heart className="w-4 h-4 fill-white" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-serif text-lg mb-5">Navigation</div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li><a href="#accueil" className="hover:text-gold transition-colors">Accueil</a></li>
              <li><a href="#direct" className="hover:text-gold transition-colors">Culte en direct</a></li>
              <li><a href="#cultes" className="hover:text-gold transition-colors">Cultes passés</a></li>
              <li><a href="#apropos" className="hover:text-gold transition-colors">À propos</a></li>
              <li><a href="#evenements" className="hover:text-gold transition-colors">Événements</a></li>
              <li><a href="#contact" className="hover:text-gold transition-colors">Contact</a></li>
              <li><Link to="/admin/login" className="hover:text-gold transition-colors">Espace admin</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="font-serif text-lg mb-5">Nous trouver</div>
            <ul className="space-y-4 text-white/70 text-sm">
              <li className="flex gap-3"><MapPin className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />{info?.address}</li>
              <li className="flex gap-3"><Phone className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />{info?.phone}</li>
              <li className="flex gap-3"><Mail className="w-4 h-4 mt-0.5 text-gold flex-shrink-0" />{info?.email}</li>
            </ul>

            <div className="mt-6 flex gap-3">
              <SocialLink href={info?.facebook_url} icon={Facebook} label="Facebook" />
              <SocialLink href={info?.youtube_url} icon={Youtube} label="YouTube" />
              <SocialLink href={info?.instagram_url} icon={Instagram} label="Instagram" />
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
          <div>© {new Date().getFullYear()} {info?.name}. Tous droits réservés.</div>
          <div>Fait avec <Heart className="inline w-3 h-3 fill-gold text-gold" /> pour la gloire de Dieu.</div>
        </div>
      </div>
    </footer>
  );
}

function SocialLink({ href, icon: Icon, label }) {
  return (
    <a
      href={href || "#"}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      data-testid={`social-${label.toLowerCase()}`}
      className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-white/80 hover:bg-gold hover:text-white hover:border-gold transition-all"
    >
      <Icon className="w-4 h-4" />
    </a>
  );
}
